import axios from "axios";
import $ from "jquery";

const state = {
  quotesStatistics: {},
  operatorQuotes: {},
};

const getters = {
  quotesStatistics(state) {
    return state.quotesStatistics;
  },

  operatorQuotes(state) {
    return state.operatorQuotes;
  },
};

const mutations = {
  setQuotesStatistics(state, statistics) {
    state.quotesStatistics = statistics;
  },

  setOperatorQuotes(state, quotes) {
    state.operatorQuotes = quotes;
  },

  setQuoteStatus(state, data) {
    let index = state.operatorQuotes.findIndex((q) => q.id == data.id);
    state.operatorQuotes[index].status = data.status;
  },

  deleteQuote(state, id) {
    let index = state.operatorQuotes.findIndex((q) => q.id == id);
    state.operatorQuotes.splice(index, 1);
  },
};

const actions = {
  async fetchQuotesStatistics({ commit, rootState }) {
    const apiUrl = process.env.VUE_APP_API_URL;
    const accessToken = rootState.authStore.token;
    const user = rootState.authStore.user;
    const filter = user.role == "operator" ? `?operator=${user.id}` : "";

    await axios
      .get(`${apiUrl}/quote/statistics${filter}`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((res) => {
        commit("setQuotesStatistics", res.data);
      });
  },

  async fetchOperatorQuotes({ commit, dispatch, rootState }, operator = 0) {
    const apiUrl = process.env.VUE_APP_API_URL;
    const accessToken = rootState.authStore.token;

    if (!operator) {
      await axios
        .get(`${apiUrl}/quote/request`, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        })
        .then((res) => {
          commit("setOperatorQuotes", res.data);

          dispatch("hideBarLoading", null, { root: true });
        });
    } else {
      await axios
        .get(`${apiUrl}/quote/request/${operator}`, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        })
        .then((res) => {
          commit("setOperatorQuotes", res.data);

          dispatch("hideBarLoading", null, { root: true });
        });
    }
  },

  async updateQuoteStatus({ commit, dispatch, rootState }, data) {
    dispatch("showSpinnerLoading", null, { root: true });

    const apiUrl = process.env.VUE_APP_API_URL;
    const accessToken = rootState.authStore.token;

    axios
      .put(
        `${apiUrl}/quote/status/update?id=${data.id}&status=${data.status}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      )
      .then(() => {
        $.alert("Status updated successfull");
        commit("setQuoteStatus", data);

        dispatch("hideSpinnerLoading", null, { root: true });
      });
  },

  async deleteOperatorQuote({ commit, dispatch, rootState }, id) {
    dispatch("showSpinnerLoading", null, { root: true });

    const apiUrl = process.env.VUE_APP_API_URL;
    const accessToken = rootState.authStore.token;

    await axios
      .delete(`${apiUrl}/quote/delete?id=${id}`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then(() => {
        $.alert("quote deleted successfull");
        commit("deleteQuote", id);

        dispatch("hideSpinnerLoading", null, { root: true });
      });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
